<template>
  <div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && fornecedorDetalhes">
      <px-cadastro-fornecedor-nacional-dados :fornecedor-detalhes="fornecedorDetalhes"/>
      <div class="mt-10">
        <v-row dense>
          <v-col cols="12" sm="12">
            <v-text-field
              dense
              outlined
              hide-details
              label="Nome"
              class="required rounded-tag-small"
              :error="$v.fornecedorCadastro.nome.$error"
              @blur="$v.fornecedorCadastro.nome.$touch()"
              v-model="fornecedorCadastro.nome"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="5">
            <v-text-field
              dense
              outlined
              hide-details
              label="Código interno"
              class="rounded-tag-small"
              v-model="fornecedorCadastro.codigoInterno"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-switch dense
                      hide-details
                      class="pa-0 mt-2 mr-2"
                      label="É transportadora?"
                      color="primary"
                      v-model="fornecedorCadastro.transportadora"/>
          </v-col>
          <v-col cols="12" sm="5">
            <v-text-field v-if="fornecedorCadastro.transportadora"
              dense
              outlined
              hide-details
              label="Código interno da transportadora"
              class="rounded-tag-small"
              v-model="fornecedorCadastro.codigoTransportadora"
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="9">
            <v-textarea
              outlined
              auto-grow
              class="rounded-tag-small"
              label="Observações internas"
              counter="1500"
              rows="1"
              v-model="fornecedorCadastro.observacoesInternas"
            />
          </v-col>
          <v-col cols="12" sm="3">
            <px-switch-tooltip
              v-model="fornecedorCadastro.permiteEdicaoCotacao"
              label="Editar cotações"
              tooltip="Habilita a edição das respostas submetidas por este fornecedor no<br>
                processo de cotação, desde que não possua negociação em aberto."/>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="6">
            <px-cadastro-fornecedor-emails ref="emails"
                                           :fornecedor-cadastro="fornecedorCadastro"/>
          </v-col>
          <v-col cols="12" sm="6">
            <px-cadastro-fornecedor-telefones ref="telefones"
                                              nacional
                                              :fornecedor-cadastro="fornecedorCadastro"/>
          </v-col>
        </v-row>
        <div class="mt-3">
          <v-btn
            color="primary"
            class="rounded-tag-small normal-btn-text elevation-0"
            :loading="loadingSave"
            @click="onClickSalvar">
            Salvar
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GestaoFornecedorService from '@/modules/gestao-fornecedor/gestao-fornecedor-service';
import { onlyNumbers } from '@/utils/regex-utils';
import { isValid } from '@/utils/validate-cnpj';
import CadastroFornecedorNacionalDados
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorNacionalDados.vue';
import { required } from 'vuelidate/lib/validators';
import CadastroFornecedorEmails
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorEmails.vue';
import CadastroFornecedorTelefones
  from '@/modules/gestao-fornecedor/gestao/cadastro/CadastroFornecedorTelefones.vue';
import validationMixin from '@/mixins/validation-mixin';

export default {
  mixins: [validationMixin],
  props: {
    fornecedor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      loadingSave: false,
      fornecedorDetalhes: null,
      fornecedorCadastro: {
        nome: null,
        codigoInterno: null,
        codigoTransportadora: null,
        transportadora: false,
        observacoesInternas: null,
        permiteEdicaoCotacao: true,
        emails: [],
        whatsapps: [],
      },
    };
  },
  methods: {
    getFornecedorFromCnpj() {
      this.loading = true;
      this.emitOnLoading(this.loading);
      const cnpj = onlyNumbers(this.fornecedor.documento);
      GestaoFornecedorService.getFromCnpj(cnpj)
        .then((response) => {
          this.fornecedorDetalhes = response.data;
        })
        .catch(() => {
          this.$toast('Fornecedor não encontrado, verifique o cnpj informado.', { color: 'error' });
        })
        .finally(() => {
          this.loading = false;
          this.emitOnLoading(this.loading);
        });
    },
    emitOnLoading(loading) {
      this.$emit('loading', loading);
    },
    validarFormEDependencias() {
      const emails = this.$refs.emails.validate();
      const telefones = this.$refs.telefones.validate();
      return emails || telefones || this.validateForm();
    },
    onClickSalvar() {
      if (this.validarFormEDependencias()) {
        return;
      }
      this.salvar();
    },
    buildPayload() {
      const receitaFornecedor = { ...this.fornecedorDetalhes };
      const fornecedor = { ...this.fornecedorCadastro };
      return {
        ...receitaFornecedor,
        id: receitaFornecedor.id ? receitaFornecedor.id : undefined,
        pessoa: {
          ...receitaFornecedor.pessoa,
          id: receitaFornecedor.pessoa.id ? receitaFornecedor.pessoa.id : undefined,
        },
        endereco: {
          ...receitaFornecedor.endereco,
          id: receitaFornecedor.endereco.id ? receitaFornecedor.endereco.id : undefined,
        },
        whatsapps: fornecedor.whatsapps.map(t => t.value),
        emails: fornecedor.emails.map(e => e.value),
        nome: fornecedor.nome,
        codigoInterno: fornecedor.codigoInterno,
        observacoesInternas: fornecedor.observacoesInternas,
        permiteEdicaoCotacao: fornecedor.permiteEdicaoCotacao,
        transportadora: fornecedor.transportadora,
        codigoTransportadora: fornecedor.codigoTransportadora,
      };
    },
    salvar() {
      this.loadingSave = true;
      this.emitOnLoading(this.loadingSave);

      GestaoFornecedorService.saveFornecedorGestao(this.buildPayload())
        .then((content) => {
          this.$toast('Fornecedor salvo com sucesso!', { color: 'success' });
          this.$router.push({
            name: 'main.gestao-fornecedores.fornecedor',
            params: { id: content.data.idDetalhes },
          });
        })
        .finally(() => {
          this.loadingSave = false;
          this.emitOnLoading(this.loadingSave);
        });
    },
  },
  watch: {
    'fornecedor.documento': {
      handler(newValue, oldValue) {
        if (newValue === oldValue) {
          return;
        }
        if (!isValid(newValue)) {
          return;
        }
        this.getFornecedorFromCnpj();
      },
      deep: true,
    },
  },
  created() {
    this.getFornecedorFromCnpj();
  },
  validations: {
    fornecedorCadastro: {
      nome: {
        required,
      },
    },
  },
  components: {
    pxCadastroFornecedorNacionalDados: CadastroFornecedorNacionalDados,
    pxCadastroFornecedorEmails: CadastroFornecedorEmails,
    pxCadastroFornecedorTelefones: CadastroFornecedorTelefones,
  },
};
</script>
